import { get } from "lodash";
import {
  MANAGE_MASTER_SET_FLOW,
  MANAGE_MASTER_SET_SELECTED_MENU,
  MANAGE_MASTER_SET_TOAST_INFO,
  MANAGE_MASTER_LOCAL_CACHE,
  MANAGE_MASTER_CLEAR_LOCAL_CACHE,
  MANAGE_MASTER_POST_API_ERROR,
  MANAGE_MASTER_INNER_DETAILS,
} from "./actions";

const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case MANAGE_MASTER_SET_SELECTED_MENU:
      return {
        ...state,
        selectedMenu: payload,
      };
    case MANAGE_MASTER_SET_FLOW:
      return {
        ...state,
        ...payload,
      };
    case MANAGE_MASTER_SET_TOAST_INFO: {
      return {
        ...state,
        showToast: get(payload, "showToast", false),
        toastMessage: get(payload, "toastMessage", ""),
      };
    }
    case MANAGE_MASTER_LOCAL_CACHE:
      return {
        ...state,
        [payload.model]: payload.data,
      };
    case MANAGE_MASTER_CLEAR_LOCAL_CACHE:
      delete state[payload];
      return {
        ...state,
      };
    case MANAGE_MASTER_INNER_DETAILS:
      return {
        ...state,
        innerDetailsFlag: payload,
      };
    case MANAGE_MASTER_POST_API_ERROR:
      return {
        ...state,
        api: {
          ...state.api,
          isFetching: false,
          isError: true,
          error: payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
